module.exports = __webpack_public_path__ + "img/blockS4-1.0e53813f.svg";